class PlaceholderHandler {
  private element: HTMLInputElement | HTMLTextAreaElement;
  private originalPlaceholder: string | undefined; // Le type peut être string ou undefined

  /**
   * @param selector Le sélecteur CSS du champ de formulaire (ex: '#myInput', '.text-field').
   */
  constructor(selector: string) {
    this.element = document.querySelector(selector) as
      | HTMLInputElement
      | HTMLTextAreaElement;

    if (!this.element) {
      console.error(`Element with selector "${selector}" not found.`);
      return;
    }

    this.originalPlaceholder = this.element.placeholder;

    this.addEventListeners();
  }

  private addEventListeners(): void {
    this.element.addEventListener('focus', this.handleFocus.bind(this));
    this.element.addEventListener('blur', this.handleBlur.bind(this));
  }

  private handleFocus(): void {
    this.element.placeholder = '';
  }

  private handleBlur(): void {
    if (this.element.value === '') {
      // Vous devrez vérifier si originalPlaceholder est défini avant de l'assigner
      if (this.originalPlaceholder !== undefined) {
        this.element.placeholder = this.originalPlaceholder;
      } else {
        // Ou gérer le cas où il n'y avait pas de placeholder original
        this.element.placeholder = ''; // Ou ne rien faire
      }
    }
  }

  // private handleBlur(): void {
  //   if (this.element.value === '') {
  //     this.element.placeholder = this.originalPlaceholder;
  //   }
  // }

  /**
   * Permet de désactiver le gestionnaire d'événements si nécessaire.
   */
  public destroy(): void {
    this.element.removeEventListener('focus', this.handleFocus.bind(this));
    this.element.removeEventListener('blur', this.handleBlur.bind(this));
  }
}

// Pour l'utiliser :
document.addEventListener('DOMContentLoaded', () => {
  // Crée une instance pour un input avec l'ID 'myInput'
  const inputMail = new PlaceholderHandler('.mail');
  const inputTel = new PlaceholderHandler('.tel');

  // Crée une instance pour un textarea avec la classe 'myTextarea'
  // const textareaHandler = new PlaceholderHandler('.myTextarea');

  // Si vous avez plusieurs champs avec la même classe et voulez appliquer le comportement à tous :
  // const allInputs = document.querySelectorAll('.myClass');
  // allInputs.forEach(input => {
  //     new PlaceholderHandler(`#${input.id}`); // Assurez-vous que chaque input a un ID unique
  // });
});

// supprimer le formulaire de contact après l'envoi réussi

class RemoveFormSuccess {
  private contactFormContainerSelector: string;

  /**
   * @param containerSelector Le sélecteur CSS du conteneur de votre formulaire
   * (par exemple, '.contact-form').
   */
  constructor(containerSelector: string) {
    this.contactFormContainerSelector = containerSelector;
    this.init();
  }

  private init(): void {
    // Attendre que le DOM soit complètement chargé pour s'assurer que Contact Form 7 est prêt.
    // Bien que 'wpcf7mailsent' soit déclenché plus tard, c'est une bonne pratique.
    document.addEventListener('DOMContentLoaded', () => {
      this.setupEventListener();
    });
  }

  private setupEventListener(): void {
    // Contact Form 7 déclenche un événement personnalisé 'wpcf7mailsent'
    // lorsque le formulaire est envoyé avec succès.
    document.addEventListener(
      'wpcf7mailsent',
      (event: Event) => {
        this.hideFormContainer();
      },
      false
    );
  }

  private hideFormContainer(): void {
    const contactFormContainer = document.querySelector(
      this.contactFormContainerSelector
    ) as HTMLElement;

    if (contactFormContainer) {
      // Option 1 : Masquer instantanément le conteneur
      contactFormContainer.style.display = 'none';

      // Option 2 : Masquer avec une transition en douceur (décommenter pour l'activer)
      /* contactFormContainer.style.opacity = '0';
      contactFormContainer.style.transition = 'opacity 0.5s ease-out';
      setTimeout(() => {
        contactFormContainer.style.display = 'none';
      }, 500); // Attend 0.5 secondes pour que la transition se termine*/

      // Option 3 : Ajouter un message de remerciement (décommenter pour l'activer)
      const successMessage = document.createElement('p');
      successMessage.className = 'success-message-custom';
      successMessage.innerHTML = `<b>Merci de nous avoir envoyé vos coordonnées !</b> </br>Nous vous contacterons d'ici peu.`;
      // Insère le message après le conteneur du formulaire
      contactFormContainer.parentNode?.insertBefore(
        successMessage,
        contactFormContainer.nextSibling
      );
    }
  }
}

// Pour initialiser la classe une fois que le script est chargé et exécuté,
// instanciez-la en lui passant le sélecteur de votre conteneur de formulaire.
// Assurez-vous que votre conteneur de formulaire a bien la classe 'contact-form'.
new RemoveFormSuccess('.contact-form');

// Fichier : display-form-errors.ts

class DisplayFormErrors {
  private errorOutputSelector: string;

  /**
   * @param errorOutputSelector Le sélecteur CSS de la div où afficher les erreurs
   * (par exemple, '.footer-primary__error').
   */
  constructor(errorOutputSelector: string) {
    this.errorOutputSelector = errorOutputSelector;
    this.init();
  }

  private init(): void {
    document.addEventListener('DOMContentLoaded', () => {
      this.setupEventListener();
    });
  }

  private setupEventListener(): void {
    // 'wpcf7invalid' est déclenché quand le formulaire est soumis avec des erreurs de validation
    document.addEventListener(
      'wpcf7invalid',
      (event: Event) => {
        this.addErrorMessagesToOutput();
      },
      false
    );

    // 'wpcf7mailsent' est déclenché en cas de succès, on peut en profiter pour vider les erreurs précédentes
    document.addEventListener(
      'wpcf7mailsent',
      (event: Event) => {
        this.clearErrorMessages();
      },
      false
    );
  }

  private addErrorMessagesToOutput(): void {
    const errorOutputDiv = document.querySelector(
      this.errorOutputSelector
    ) as HTMLElement;

    if (errorOutputDiv) {
      // Vider le contenu précédent de la div d'erreur avant d'ajouter de nouveaux messages
      errorOutputDiv.innerHTML = '';
      errorOutputDiv.style.display = 'block'; // S'assurer que la div est visible

      // Sélectionner tous les messages d'erreur de Contact Form 7
      const errorTips = document.querySelectorAll('.wpcf7-not-valid-tip');

      if (errorTips.length > 0) {
        // Créer une liste pour les messages d'erreur pour une meilleure lisibilité
        const errorList = document.createElement('ul');
        errorList.style.listStyleType = 'none'; // Enlève les puces par défaut
        errorList.style.padding = '0';
        errorList.style.margin = '0'; // Assure qu'il n'y a pas de marge par défaut

        errorTips.forEach((tip, index) => {
          if (tip.textContent) {
            const listItem = document.createElement('li');
            listItem.textContent = tip.textContent;
            errorList.appendChild(listItem);

            // === AJOUT DU SAUT DE LIGNE ICI ===
            // Si vous voulez un saut de ligne *entre* chaque message, sauf le dernier
            // if (index < errorTips.length - 1) {
            //     errorList.appendChild(document.createElement('br'));
            // }

            // Si vous voulez une marge entre les éléments de la liste via CSS,
            // vous pouvez ajouter une classe à votre <li> et styliser avec du CSS
            // listItem.classList.add('error-message-item');
            // Ou directement ici:
            listItem.style.marginBottom = '5px'; // Exemple: ajoute un espace de 5px sous chaque message
          }
        });
        errorOutputDiv.appendChild(errorList);

        // Optionnel : Ajouter un titre général pour les erreurs
        const generalErrorTitle = document.createElement('p');
        generalErrorTitle.textContent =
          'Veuillez corriger les erreurs suivantes :';
        generalErrorTitle.style.fontWeight = 'bold';
        generalErrorTitle.style.marginBottom = '10px'; // Espace sous le titre
        errorOutputDiv.prepend(generalErrorTitle); // Ajoute le titre au début de la div
      } else {
        errorOutputDiv.style.display = 'none'; // Cacher si aucun message d'erreur n'est trouvé
      }
    }
  }

  private clearErrorMessages(): void {
    const errorOutputDiv = document.querySelector(
      this.errorOutputSelector
    ) as HTMLElement;
    if (errorOutputDiv) {
      errorOutputDiv.innerHTML = '';
      errorOutputDiv.style.display = 'none'; // Cacher la div après un succès
    }
  }
}

// Initialisez la classe pour cibler votre div de sortie d'erreur
new DisplayFormErrors('.footer-primary__error');
